module.exports = __webpack_public_path__ + "img/ploschadka_2_y_etazh.f0073e7f.svg";